import React from 'react'
import { classcardProps } from './classcard-interface'
import { useNavigate } from 'react-router-dom'

const Classcard = ({ details }: classcardProps) => {
	const navigate = useNavigate()
	
	return (
		<div className='flex rounded-[1.8rem] custom-light-purple-bg-faint p-4 pt-6 mb-8'>

			<img src={`/img/vectors/${details?.languageId?.name.toLowerCase() === 'python' ? 'classpython.svg' : 'classnormal.svg'}`} alt="classpython" className='w-[14.3rem] h-[8.1rem]' />

			<div className='flex-1 pl-1'>
				<p className='mb-2 text-lg font-bold capitalize text-appcolorblackfainteleven'>
					{details.name}
				</p>
				<p className='mb-2 text-base capitalize text-appcolorblackfainteleven'>
					{details?.description}
				</p>
				<div className='flex items-center justify-between'>
					<div className="flex items-center">
						<div className='custom-piped pr-[0.6rem] custom-piped-curicard'>
							<img src={`${details?.teacherId?.userAvatarURL === undefined ?
								'/img/vectors/usertag.svg'
								:
								details?.teacherId?.userAvatarURL === '' ?
									'/img/vectors/usertag.svg' :
									details?.teacherId?.userAvatarURL
								}`}
								alt="usertag"
								className='w-6 h-6 rounded-full'
							/>
						</div>
						<div className='ml-[0.6rem] flex items-center justify-between flex-grow'>
							<div className='flex flex-col'>
								<p className='text-xs text-appcolorblack opacity-[0.5] mb-0'>Instructor</p>
								<p className='text-sm font-medium text-appcolorpurplefaintone'>{details?.teacherId?.firstName}</p>
							</div>
						</div>
					</div>

					<div>
						<div className='cursor-pointer w-fit p-[0.6rem] px-4 flex custom-deep-yellow-bg rounded-[1.2rem]'
						onClick={() => {
							navigate(`/student/dashboard/class/${details?._id}`)
						}}
						>
							<span className='pr-1 text-sm text-appcolorwhite'>
								View
							</span>
							<img src="/img/vectors/view.svg" alt="view" />
						</div>
					</div>
				</div>
			</div>

		</div>
	)
}

export default Classcard